import store from "@/store";

export const defaultRowPainter = items =>
  items.map(item => {
    let newItem = { ...item };
    if (Number(item.is_deleted)) newItem._rowVariant = "danger";
    return newItem;
  });

export const peopleRowPainter = people =>
  defaultRowPainter(
    people.map(person => {
      let newPerson = { ...person };
      if (person.vip_status !== null) newPerson._rowVariant = "gold";
      return newPerson;
    })
  );

export const gymClientRowPainter = gymClients =>
  defaultRowPainter(
    gymClients.map(gymClient => {
      let newGymClient = { ...gymClient };
      if (gymClient.acquired_at) newGymClient._rowVariant = "success";
      if (
        gymClient.person.vip_status !== null &&
        store.getters["user/hasRole"](["root", "admin"])
      )
        newGymClient._rowVariant = "gold";
      return newGymClient;
    })
  );
